import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingCancellationInfoState = {
  value: BookingDetails['cancellation'] | null;
};

const initialState: BookingCancellationInfoState = {
  value: null,
};

function setBookingCancellationInfoFunction(
  state: BookingCancellationInfoState,
  action: PayloadAction<BookingCancellationInfoState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingCancellationInfo',
  initialState,
  reducers: {
    setBookingCancellationInfo: setBookingCancellationInfoFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingCancellationInfo, resetState } = slice.actions;
export default slice.reducer;
